module.exports = __webpack_public_path__ + "static/img/bg-m-0518-mid.90729b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg-m-0518-mid.jpg
// module id = UNVB
// module chunks = 1